module.exports = __webpack_public_path__ + "static/media/close.506c8461.svg";